import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Language } from '~/types';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 152px;
    min-height: 152px;
    padding: 16px;
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_dark_2};
    cursor: pointer;
  `}
`;

export const ChatTitle = styled.h3`
  ${({ theme }) => css`
    display: block;
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body18_bold};
    ${theme.mixins.text.ellipsis_1};
    font-family: Poppins;
  `}
`;

export const ChatDescription = styled.div`
  ${({ theme }) => css`
    display: block;
    color: ${theme.content.content_light_2};
    ${theme.mixins.text.ellipsis_2};
    ${theme.fontStyle.text.body14_medium};
  `}
`;

export const BottomWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: flex-end;
  align-self: stretch;
  justify-content: space-between;
  width: 100%;
  height: 32px;
`;

export const RoomInformation = styled.p<{ language?: Language }>`
  ${({ theme, language }) => css`
    display: flex;
    align-items: center;
    color: ${theme.content.content_light_3};

    ${language &&
    css`
      color: ${language === 'English'
        ? theme.point.point_bg_1
        : language === '中文'
        ? theme.point.point_bg_2
        : language === 'Español'
        ? theme.point.point_bg_3
        : language === 'Bahasa Indonesia'
        ? theme.point.point_bg_4
        : language === '日本語'
        ? theme.point.point_bg_5
        : language === 'Português'
        ? theme.point.point_bg_6
        : language === 'Русский'
        ? theme.point.point_bg_7
        : language === 'Français'
        ? theme.point.point_bg_8
        : theme.point.point_bg_1};
    `}

    span {
      ${theme.fontStyle.text.body16_medium};
    }
  `}
`;

export const JoinButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 85px;
    height: 32px;
    padding: 4px 16px 4px 12px;
    border-radius: 24px;
    background: ${theme.backgroundColor.bg_dark_3};
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body16_medium};
  `}
`;
